import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';

import { contactForDefault } from '../utils/contactCustomerService';
import { desktopFooterClick } from '../utils/ga/category06';
import {
  HELP_HOST,
  SALES_MAIL,
  // 關於我們
  JOBBANK_URL,
  FACEBOOK_FAN_URL,
  INSTAGRAM_FAN_URL,
  YOUTUBE_FAN_URL,
  // 服務條款
  SERVICE_TERMS_URL,
  PRIVACY_TERMS_URL,
  PAYMENT_VIP_TERMS_URL,
  PACKAGE_SUBSCRIBE_TERMS_URL,
  PACKAGE_RENT_TERMS_URL,
} from '../../constants/service';
import imageSrc from '../../common/image';

const LinksContainer = styled.div`
  flex-basis: 25%;
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
`;

const Title = styled.div`
  align-self: start;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 1.5rem;
`;

const Link = styled.a`
  align-self: start;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-brand-grey-800);
  margin-bottom: 1rem;
`;

export default function Footer(props) {
  const years = new Date().getFullYear();
  return (
    <footer className={cx('w-full bg-brand-grey-200 content-visibility-auto', props.className)}>
      <div className="container pt-16 pb-2 flex flex-col">
        <div className="flex-auto flex">
          <LinksContainer>
            <Title>關於我們</Title>
            <Link className="hover:underline" href={JOBBANK_URL} target="_blank" rel="noopener nofollow">加入我們</Link>
            <button type="button" className="self-start outline-none hover:underline focus:outline-none" onClick={() => contactForDefault('聯絡 LINE TV')}>聯絡我們</button>
          </LinksContainer>
          <LinksContainer>
            <Title>異業合作</Title>
            <Link className="hover:underline" href={`mailto:${SALES_MAIL}?subject=LINE TV 廣告業務`}>廣告業務</Link>
            <Link className="hover:underline" href={`mailto:${SALES_MAIL}?subject=LINE TV 平台合作`}>平台合作</Link>
          </LinksContainer>
          <LinksContainer>
            <Title>服務條款</Title>
            <Link className="hover:underline" href={SERVICE_TERMS_URL} target="_blank" rel="noopener">用戶服務條款</Link>
            <Link className="hover:underline" href={PRIVACY_TERMS_URL} target="_blank" rel="noopener">服務隱私權政策</Link>
            <Link className="hover:underline" href={PAYMENT_VIP_TERMS_URL} target="_blank" rel="noopener">VIP 訂閱服務條款</Link>
            <Link className="hover:underline" href={PACKAGE_SUBSCRIBE_TERMS_URL} target="_blank" rel="noopener">主題訂閱服務條款</Link>
            <Link className="hover:underline" href={PACKAGE_RENT_TERMS_URL} target="_blank" rel="noopener">單部租借服務條款</Link>
          </LinksContainer>
          <LinksContainer>
            <Title>用戶幫助</Title>
            <Link className="hover:underline" href={HELP_HOST} target="_blank" rel="noopener">問題中心</Link>
            <Link className="hover:underline" href={`${HELP_HOST}/faq-categories/mst3t1En2.html`} target="_blank" rel="noopener">主題館</Link>
            <Link className="hover:underline" href={`${HELP_HOST}/announcements.html`} target="_blank" rel="noopener">訊息公告</Link>
            <button type="button" className="self-start outline-none hover:underline focus:outline-none" onClick={() => contactForDefault('LINE TV 用戶幫助')}>聯絡客服</button>
          </LinksContainer>
        </div>

        <hr className="border-brand-grey-600 mt-16" />

        <div className="flex-auto flex items-center py-6">
          <figure className="flex-none" style={{width: '100px'}}>
            <img loading="lazy" src={`${imageSrc}/logo/footer_logo.svg`} alt="LINE TV" className="w-full h-auto" />
          </figure>
          <div className="flex-auto flex justify-end items-center">
            <small className="text-14 font-500 mr-2">
              Copyright&copy;{years} CHOCO Media Co. Ltd. ALL RIGHTS RESERVED.
            </small>
            <a
              className="ml-4"
              href={YOUTUBE_FAN_URL}
              target="_blank"
              rel="noopener"
              onClick={() => desktopFooterClick('Youtube')}
            >
              <img loading="lazy" src={`${imageSrc}/svg/youtube.svg`} alt="Youtube" />
            </a>
            <a className="ml-4" href={FACEBOOK_FAN_URL} target="_blank" rel="noopener" onClick={() => desktopFooterClick('Facebook')}>
              <img loading="lazy" src={`${imageSrc}/svg/facebook.svg`} alt="Facebook" />
            </a>
            {/* <a className="ml-4" href={INSTAGRAM_FAN_URL} target="_blank" rel="noopener" onClick={() => desktopFooterClick('Instagram')}>
              <img loading="lazy" src={`${imageSrc}/svg/instagram.svg`} alt="Instagram" />
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
